<template>
    <div style="height: 100%; width: 100%; overflow: auto">
    <template>
       
      <vue-office-excel
        :src="url"
        style="height: 100vh"
        v-if="typ=='xlsx'"
      />
    </template>
    <template>
      
      <vue-office-docx
        :src="url"
        style="height: 100vh"
        v-if="typ=='docx'"
      />
    </template>
    <template>
     
       <div style="display: flex;
    justify-content: flex-end;">
<el-pagination
  small
  layout="prev, pager, next"
  :page-size="1"
  :hide-on-single-page="true"
  :current-page="currentPage"
   @current-change="qiehuan"
  :total="pageCount">
</el-pagination>

       </div>
       <pdf ref="pdf" 
          :src="url" 
          :page="currentPage"
          @num-pages="pageCount=$event"
          @page-loaded="currentPage=$event"
          @loaded="loadPdfHandler"
         >
        </pdf>
      
    </template>
  </div>
</template>

<script>

import VueOfficeExcel from "@vue-office/excel";
import VueOfficeDocx from "@vue-office/docx";

 import pdf from 'vue-pdf';
// 引入相关样式
import "@vue-office/excel/lib/index.css";
import { log } from "i18n-jsautotranslate";
export default {
   props:['url','typ'],
    components: {
    VueOfficeExcel,
    VueOfficeDocx,
  
    pdf
  },
  data() {
    return {
     
      src:'',
  currentPage: 0, // pdf文件页码
        pageCount: 0 ,// pdf文件总页数
 imgFiles: [],
      pdfName: '',
}
  },
methods: {
 
    qiehuan(e){
      console.log(e);
      this.currentPage=e
    },
      // pdf加载时
      loadPdfHandler (e) {
  
        
        this.currentPage = 1 // 加载的时候先加载第一页
      },
},
created(){
console.log(1,this.pageCount);

}
 
}
</script>

<style lang="less" scoped>

</style>